import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Heading } from 'rebass';

import { ModalWrap, LocalWrap, Spinner } from './styled';

const Loading = ({ local, showText }) => {
  if (local) {
    return (
      <LocalWrap>
        <Spinner />
      </LocalWrap>
    );
  }

  return (
    <ModalWrap>
      {showText ? <Flex width="100vw" p={2} my="auto" flexDirection="column" alignItems="center">
        <Heading className='blacktextloading' mb={3}>Putting your story together</Heading>
        <Spinner />
      </Flex> : <Spinner />}
    </ModalWrap>
  );
};

Loading.propTypes = {
  local: PropTypes.bool,
};

Loading.defaultProps = {
  local: false,
};

export default Loading;
